/**
 * The boot and route-transition placeholder.
 *
 * Deliberately not a skeleton. Skeletons belong where the shape of what is
 * coming is known — a table, a card, a form. This renders while the app is
 * still deciding *which* of those a user will see, and a skeleton of the wrong
 * layout is a worse experience than an honest wait.
 *
 * @returns The spinner
 */
export function FullPageSpinner() {
    return (
        <div
            className="flex min-h-dvh items-center justify-center bg-base"
            role="status"
            aria-live="polite"
        >
            <div className="h-8 w-8 animate-spin rounded-full border-2 border-subtle border-t-accent" />
            <span className="sr-only">Loading</span>
        </div>
    );
}
